import { StepConnector, stepConnectorClasses, styled } from '@mui/material';

export const QontoConnector = styled(StepConnector)(({ theme }) => ({
	[`&.${stepConnectorClasses.alternativeLabel}`]: {
		top: 10,
		left: 'calc(-50% + 16px)',
		right: 'calc(50% + 16px)',
	},
	[`&.${stepConnectorClasses.active}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			borderColor: theme.palette.primary.main,
		},
	},
	[`&.${stepConnectorClasses.completed}`]: {
		[`& .${stepConnectorClasses.line}`]: {
			borderColor: theme.palette.primary.main,
		},
	},
	[`& .${stepConnectorClasses.line}`]: {
		borderColor: '#eaeaf0',
		borderTopWidth: 3,
		borderRadius: 1,
		...theme.applyStyles('dark', {
			borderColor: theme.palette.grey[800],
		}),
	},
}));

export const QontoStepIconRoot = styled('div')(({ theme }) => ({
	color: '#eaeaf0',
	display: 'flex',
	height: 22,
	alignItems: 'center',
	'& .QontoStepIcon-completedIcon': {
		color: theme.palette.primary.main,
		zIndex: 1,
		fontSize: 18,
	},
	'& .QontoStepIcon-circle': {
		width: 8,
		height: 8,
		borderRadius: '50%',
		backgroundColor: 'currentColor',
	},
	...theme.applyStyles('dark', {
		color: theme.palette.grey[700],
	}),
	variants: [
		{
			props: ({ ownerState }) => ownerState.active,
			style: {
				color: theme.palette.primary.main,
			},
		},
	],
}));
